/**
 * Concrete event class emitted by the {@link Query} instance itself.
 *
 * Represents lifecycle events for query creation, completion, caching, and job management.
 * Subscribers can use `instanceof QueryEvent` to filter for query-level events
 * when the aggregated `event$` stream also contains client and cache events.
 *
 * @template TData - The type of data payload carried by this event.
 */
export class QueryEvent {
    type;
    key;
    data;
    /**
     * Creates a new Query event.
     *
     * @param type - The specific event type identifier.
     * @param key - The cache key associated with this event.
     * @param data - Optional event-specific data payload.
     */
    constructor(type, key, data) {
        this.type = type;
        this.key = key;
        this.data = data;
    }
}
//# sourceMappingURL=QueryEvent.js.map